import './banner.scss'

import {Background} from '@codeurs/front'
import {ImageType, LinkBaseType} from 'campagne/types'
import React, {FunctionComponent} from 'react'
import {style} from 'util/campagne/style'
import {Theme} from 'views/campagne/theme'
import {ButtonTertiary} from 'views/ui/Button'

export type BannerGreenType = CtaType & {
	headingLeft?: string
	headingRight?: string
}
export type BannerBasicType = CtaType

export type CtaType = {
	description?: string
	ctaText?: string
	ctaLink?: LinkBaseType
	image?: ImageType | string
	title?: string
}

const styles = style('banner', ['content'])

export const BannerCta: FunctionComponent<BannerGreenType> = ({
	headingLeft = 'Geen tijd voor een actie',
	headingRight = 'maar wil je wel delen',
	description = 'Lorem ipsum',
	ctaLink = null,
	image
}) => {
	return (
		<div class={styles.mod('cta')}>
			<BannerContent>
				<div class={styles.content('title')}>
					<Theme.H2Parted firstLabel={headingLeft} secondLabel={headingRight} />
				</div>
				<div class={styles.content('bottom')}>
					<Theme.P>{description}</Theme.P>
					{ctaLink && (
						<ButtonTertiary mod="boldtext" to={ctaLink.url} id="gift-banner">
							{ctaLink.description || ctaLink.title}
						</ButtonTertiary>
					)}
				</div>
			</BannerContent>
			{image && <Background img={image} class={styles('image').toString()} />}
		</div>
	)
}

export const BannerLight: FunctionComponent<BannerBasicType> = ({
	title,
	description,
	ctaLink,
	image
}) => {
	return (
		<div class={styles.mod('light')}>
			<BannerContent>
				<Theme.H2 mod={{green: true, small: true}}>{title}</Theme.H2>
				<div class={styles.content('bottom')}>
					<Theme.P>{description}</Theme.P>
					{ctaLink && (
						<Theme.Button
							mod={{
								transparent: true,
								outline: true,
								boldtext: true,
								whitebg: true
							}}
							to={ctaLink.url}
						>
							{ctaLink.description || ctaLink.title}
						</Theme.Button>
					)}
				</div>
			</BannerContent>
			{image && <Background img={image} class={styles('image').toString()} />}
		</div>
	)
}

export const BannerContent: FunctionComponent = ({children, ...props}) => (
	<div class={styles.content} {...props}>
		{children}
	</div>
)

export type BannerCustomType = BannerBasicType & {
	text_position: 'left' | 'right'
	background_color: 'grey' | 'green'
	secondtitle: string
	link?: LinkBaseType
	title_unmarked: boolean
}

export const BannerCampaign: FunctionComponent<BannerCustomType> = ({
	title,
	title_unmarked,
	link,
	description,
	image,
	background_color,
	secondtitle = null,
	text_position
}) => {
	return (
		<div
			class={styles.mod([
				background_color[0],
				secondtitle && 'secondtitle',
				'campaign',
				text_position[0] === 'right' && 'textright'
			])}
		>
			<BannerContent>
				<div class={styles.content('title')}>
					{secondtitle ? (
						<Theme.H2Parted firstLabel={title} secondLabel={secondtitle} />
					) : (
						<Theme.H2
							mod={{
								white:
									(!title_unmarked && background_color[0] === 'grey') ||
									(title_unmarked && background_color[0] === 'green'),
								green:
									(title_unmarked && background_color[0] === 'grey') ||
									(!title_unmarked && background_color[0] === 'green'),
								small: true,
								slantedtoleft: !title_unmarked,
								nobackground: title_unmarked
							}}
						>
							{title}
						</Theme.H2>
					)}
				</div>
				<div class={styles.content('bottom')}>
					<Theme.P>{description}</Theme.P>
					{link && (
						<Theme.Button
							mod={{
								transparent: background_color[0] === 'grey',
								outline: true,
								whitebg: background_color[0] === 'grey',
								boldtext: true
							}}
							to={link.url}
						>
							{link.description || link.title}
						</Theme.Button>
					)}
				</div>
			</BannerContent>
			{image && <Background img={image} class={styles('image').toString()} />}
		</div>
	)
}
